import * as React from "react";
import type { SVGProps } from "react";
const SvgEditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="edit_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M819.499 136.832a47.83 47.83 0 0 1 67.669 67.67l-396.97 396.97-90.24 22.57 22.57-90.24 396.97-396.97zm33.834-99.285a133.182 133.182 0 0 0-94.165 38.997L353.835 481.877a42.667 42.667 0 0 0-11.222 19.84l-42.666 170.667a42.667 42.667 0 0 0 51.754 51.712l170.667-42.667a42.624 42.624 0 0 0 19.797-11.221L947.5 264.875a133.163 133.163 0 0 0-94.166-227.328zm-640 47.786a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V512a42.667 42.667 0 1 0-85.334 0v298.667a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666H512a42.667 42.667 0 1 0 0-85.334H213.333z"
    />
  </svg>
);
export default SvgEditIcon;
